import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';

/**
 * FAQ (handoff §7): four static glass panels, not an accordion - four
 * questions is few enough that hiding the answers only adds a click.
 *
 * The photo-retention answer deliberately departs from the handoff, which
 * claimed photos are "discarded" outright. Our own Privacy Policy says the
 * AI provider may hold data up to 30 days for security monitoring, and a
 * marketing page must not contradict the policy it links to. Still wants a
 * legal read before this ships publicly.
 *
 * Same rule, second application (2026-08-30): this panel said flatly that
 * "your recipes live on your device". Recipe sync (#696) makes that
 * conditional, and the policy was updated to say so on the same day - so
 * the page had to move with it. A marketing claim that outlives the
 * feature it describes is how a privacy policy ends up being the only
 * honest page on the site.
 */
const FAQ = () => (
  <section id="faq" className="section" aria-labelledby="faq-headline">
    <div className="section-inner">
      <Reveal>
        <div className="eyebrow">FAQ</div>
        <h2 id="faq-headline" className="h2 section-headline">
          Before you download.
        </h2>
        <div className="faq-grid">
          <div className="faq-panel">
            <div className="h3">Does it work on any dish?</div>
            <p className="body-copy">
              Anything recognisable on a plate. Every result arrives as an editable draft, so when
              it reads the chilli as paprika you fix one line rather than starting over.
            </p>
          </div>
          <div className="faq-panel">
            <div className="h3">What happens to my photos?</div>
            <p className="body-copy">
              They're sent for analysis and never stored on our servers or used to train models. Our
              AI provider may hold them briefly - up to 30 days - for its own abuse monitoring, then
              deletes them. Photos are never synced between devices. Your recipes live on your
              device unless you switch on recipe sync, which keeps a copy of their text on your
              account so your other devices have them - and you can delete everything, synced copies
              included, from Settings in one tap. The{' '}
              <Link to="/privacy-policy">Privacy Policy</Link> has the full details.
            </p>
          </div>
          <div className="faq-panel">
            <div className="h3">Do I lose recipes if I cancel?</div>
            <p className="body-copy">
              No. Everything you saved stays readable, shoppable and cookable on the free tier - you
              just get fewer new scans each month.
            </p>
          </div>
          <div className="faq-panel">
            <div className="h3">Can I import from the web?</div>
            <p className="body-copy">
              Paste any recipe URL, or paste the recipe text itself. Snapcipe strips the life story
              and keeps the ingredients and method.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FAQ;
